import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import Schemas
// import Schema from '../../../../../../lib/paths/mittelabruf_FULL_Paths.json';
// const P = Schema.attributes;

const ErklaerungAbruf: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Erklärung' description={PLATZHALTER_TEXT} />

			<CreateForm formValues={application} formStruc={formstruc()} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default ErklaerungAbruf;
const formstruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				// { ...P.Erklaerungen_Erklaerungen_Block_1_Zelle_1, type: 'checkbox', validation: [{ validateFunction: ForceTrue }] },
				// { ...P.Erklaerungen_Erklaerungen_Block_2_Zelle_1, type: 'checkbox', validation: [{ validateFunction: ForceTrue }] },
				// { ...P.Erklaerungen_Erklaerungen_Block_3_Zelle_1, type: 'checkbox', validation: [{ validateFunction: ForceTrue }] },
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const formStrucErklaerungAbruf = () => {
	return concat(formstruc());
};
